// extracted by mini-css-extract-plugin
module.exports = {"card":"ValidationQueue-module__card___2wAij","table":"ValidationQueue-module__table___3LnnY"};